import { render, staticRenderFns } from "./oneNonis.vue?vue&type=template&id=8e9ef22c&scoped=true&"
import script from "./oneNonis.vue?vue&type=script&lang=js&"
export * from "./oneNonis.vue?vue&type=script&lang=js&"
import style0 from "./oneNonis.vue?vue&type=style&index=0&id=8e9ef22c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9ef22c",
  null
  
)

export default component.exports